import React, { createContext, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { platformRoles, platformRolesAndPermissions } from '../_helpers/types';
import { get_user_action } from '../_redux/action/_auth/auth.action';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [authenticated, setAuthenticated] = useState(false);
  const [userLoading, setUserLoading] = useState(false);

  const { user, loggedIn } = useSelector((state) => state.get_user_reducer);

  useEffect(() => {
    const getUser = async () => {
      setUserLoading(true);
      await dispatch(get_user_action());
      setUserLoading(false);
    };
    getUser();
  }, [ dispatch]);

  // Update authenticated state when authState changes
  useEffect(() => {
    setAuthenticated(loggedIn);
  }, [loggedIn]);

  const checkPermission = (permission) => {
    let allowed = false;

    if (user?.role) {
      if (user.role === platformRoles.admin) {
        allowed = true;
      } else {
        const rolePermissions = platformRolesAndPermissions.find((role) => role.name === user.role);
        if (rolePermissions && rolePermissions.permissions.includes(permission)) {
          allowed = true;
        }
      }
    }
    return allowed;
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        userLoading,
        authenticated,
        setAuthenticated,
        checkPermission,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
